module.exports = __webpack_public_path__ + "static/media/tire-pressure.7ba44485.svg";